<template>
  <div
    class="data-clear"
    :class="{ 'zy-data-clear': versionConfig.ZHIYUN_VERSION }"
  >
    <a-row :gutter="50">
      <a-col :span="12">
        <h2 class="title">清理门店的业务数据</h2>
        <div class="inner">
          <a-alert message="数据清理后将不可恢复,请谨慎操作" banner />
          <div class="btn">
            <a-button
              type="primary"
              block
              size="large"
              :loading="loadingBusiness"
              @click="onDelete('business')"
              >清除门店业务数据</a-button
            >
          </div>
        </div>
      </a-col>
      <a-col :span="12">
        <h2 class="title">清理门店的基础数据</h2>
        <div class="inner">
          <div
            :style="{
              borderBottom: '1px solid #E9E9E9',
              paddingBottom: '10px'
            }"
          >
            <a-checkbox
              :indeterminate="indeterminate"
              :checked="checkAll"
              @change="onCheckAllChange"
            >
              全选
            </a-checkbox>
          </div>
          <a-checkbox-group
            v-model="checkedList"
            @change="onChangeConfig"
            class="check-cnt"
          >
            <a-checkbox
              v-for="(item1, index) in configOptions"
              :key="index"
              :value="item1.value"
              >{{ item1.label }}</a-checkbox
            >
          </a-checkbox-group>
          <div class="btn">
            <a-button
              type="primary"
              :disabled="!checkedList.length"
              block
              size="large"
              :loading="loading"
              @click="onDelete('basic')"
              >清除基础数据</a-button
            >
          </div>
        </div>
      </a-col>
    </a-row>
    <a-modal
      v-model="visible"
      title="酒店编码"
      @ok="handleOk"
      :maskClosable="false"
    >
      <a-input v-model="companyCode"></a-input>
    </a-modal>
  </div>
</template>
<script>
import { cache } from "@/utils/common";
export default {
  data() {
    return {
      versionConfig,
      indeterminate: false,
      checkAll: false,
      checkedList: [],
      loading: false,
      loadingBusiness: false,
      configOptions: [
        { label: "删除客户", value: "CheckCustomer" },
        { label: "删除渠道", value: "CheckChannel" },
        { label: "删除账项", value: "CheckAccountItem" },
        { label: "删除用户角色", value: "CheckUser" },
        { label: "删除房型", value: "CheckRoomType" },
        { label: "删除房号", value: "CheckRoomNo" },
        { label: "删除价类", value: "CheckPriceCode" },
        {
          label: "删除会员数据(含会员类型，方案，消费充值记录等)",
          value: "CheckMember"
        }
      ],
      user: null,
      visible: false,
      companyCode: ""
    };
  },
  created() {
    this.user = cache.get("user");
  },
  methods: {
    onChangeConfig(checkedList) {
      this.indeterminate =
        !!checkedList.length && checkedList.length < this.configOptions.length;
      this.checkAll = checkedList.length === this.configOptions.length;
    },
    onCheckAllChange(e) {
      Object.assign(this, {
        checkedList: e.target.checked
          ? this.configOptions.map(v => v.value)
          : [],
        indeterminate: false,
        checkAll: e.target.checked
      });
    },
    deleteBasicData() {
      if (!this.checkedList.length) {
        this.$message.error("请选择清除项目");
        return false;
      }
      const _this = this;
      let txt = [];
      this.checkedList.forEach(el => {
        const str = this.configOptions.find(item => item.value == el).label;
        txt.push(str);
      });
      const rh = this.$createElement;
      const arr = txt.map((el, index) => {
        let str = el + "，";
        if (index == 0) {
          str = "【" + el + "，";
        } else if (index == txt.length - 1) {
          str = el + "】";
        }
        return rh("span", str);
      });
      arr.push(rh("p", {}, "的基础数据将会被删除，确定继续？"));
      arr.push(
        rh(
          "p",
          { class: "warning-tip" },
          "执行清除基础数据时，会自动执行一次清除门店基础数据"
        )
      );
      this.$confirm({
        title: "确定清理吗？",
        content: rh("div", {}, arr),
        onOk() {
          let params = {};
          _this.checkedList.forEach(element => {
            params[element] = true;
          });
          params.CompanyCode = _this.companyCode;
          _this.loading = true;
          _this
            .$post("DeleteBasicData", params)
            .then(() => {
              _this.$message.success("操作成功");
              _this.loading = false;
              _this.checkedList = [];
              _this.checkAll = false;
              _this.visible = false;
              _this.indeterminate = false;
              _this.companyCode = "";
            })
            .catch(() => {
              _this.loading = false;
            });
        }
      });
    },
    onDelete(type) {
      this.isBusiness = type == "business";
      this.visible = true;
    },
    deleteBusinessData() {
      const _this = this;
      if (!this.companyCode) {
        this.$message.error("请填写酒店编码");
        return false;
      }
      _this.loadingBusiness = true;
      _this
        .$post("DeleteBusinessData", { CompanyCode: _this.companyCode })
        .then(() => {
          _this.$message.success("操作成功");
          _this.loadingBusiness = false;
          _this.visible = false;
          _this.companyCode = "";
        })
        .catch(() => {
          _this.loadingBusiness = false;
        });
      // this.$confirm({
      //   title: "确定清理门店的业务数据吗？",
      //   onOk() {
      //     _this.loadingBusiness = true;
      //     _this
      //       .$post("DeleteBusinessData", { CompanyCode: _this.companyCode })
      //       .then(res => {
      //         _this.$message.success("操作成功");
      //         _this.loadingBusiness = false;
      //         _this.visible = false;
      //       })
      //       .catch(() => {
      //         _this.loadingBusiness = false;
      //       });
      //   }
      // });
    },
    handleOk() {
      if (this.isBusiness) {
        this.deleteBusinessData();
      } else {
        if (!this.companyCode) {
          this.$message.error("请填写酒店编码");
          return false;
        }
        this.deleteBasicData();
      }
    }
  }
};
</script>
<style lang="less">
.check-cnt {
  .ant-checkbox-wrapper {
    display: block;
    height: 30px;
    line-height: 30px;
    margin-left: 0;
  }
}
.data-clear {
  .title {
    background: #30abca;
    color: #fff;
  }
  .inner {
    padding: 20px 30px;
    border: 1px solid #ddd;
    border-top: 0;
    height: calc(100vh - 200px);
  }
  .btn {
    margin-top: 20px;
  }
}
.zy-data-clear {
  .title {
    background: #859fc0;
  }
}
.warning-tip {
  color: #f00;
  font-size: 12px;
  background: #fff0f0;
  padding: 0 5px;
  border-radius: 2px;
  margin-top: 10px;
}
</style>
